import React from 'react'

const Text = ({
    style,
    content,
    children,
    text_style,
}) => {
    return <p className={text_style} style={style}>
        {content}
        {children}
    </p>
}

export default Text